import AbstractController from '../../../../../vendors/services/abstractController';
import { useState } from 'react';
import EventoService from '../../../../services/evento.service';
import ContribuinteService from '../../../../services/contribuinte.service';
import AreaInteresse from '../model/area-interesse.model';
import PortalFilter from '../../../PublicPage/filters/PortalFilter';
import ToastService from '../../../../../vendors/services/toastService';
import { Mensagem } from '../../../../shared/mensagem/Mensagem';
import EventoModel from '../../../../shared/model/evento.model';
import LoginUnicoController from '../../../../../vendors/pages/Auth/controller/login-unico.controller';

export default class PerfilController extends AbstractController {

  public service: EventoService;
  public contribuinteService: ContribuinteService;
  public filter: PortalFilter;

  public value: any;
  public setValue: any;
  public user: any;

  public areasInteresse: Array<AreaInteresse>;
  public setAreasInteresse: any;
  public lista: any;
  public setLista: any;
  public listaTemporaria: any;
  public setlistaTemporaria: any;
  public lazyParams: any;
  public setLazyParams: any;
  public total: any;
  public setTotal: any;
  public dates: any;
  public setDates: any;


  constructor() {
    super();
    [this.value, this.setValue] = useState('');
    [this.lista, this.setLista] = useState([]);
    [this.listaTemporaria, this.setlistaTemporaria] = useState([]);
    [this.total, this.setTotal] = useState(0);
    [this.areasInteresse, this.setAreasInteresse] = useState([]);
    this.service = new EventoService();
    this.contribuinteService = new ContribuinteService();
    this.user = this.getUser();
    this.filter = new PortalFilter();
    [this.lazyParams, this.setLazyParams] = useState({
      first: 0,
      rows: 10,
      page: 1,
    });
    [this.dates, this.setDates] = useState(Array<Date>);
  }

  init() {
    super.init();
    const cookie = this.getCookie(LoginUnicoController.CALLBACK_LOGIN_UNICO);
    if (cookie && !!cookie.id) {
      this.setCookie(LoginUnicoController.CALLBACK_LOGIN_UNICO, {}, 1);
      this.history.push('/evento/contribuicao', {
        id: cookie.id,
        codAudienciaPublica: cookie.codAudienciaPublica
      })
    }

    this.obterDashboard();
    this.obterAreasInteresseContribuinte();
  }

  obterDashboard() {
    this.start();
    this.service.getDashboard(this.getCodContribuinte()).then((res: any) => {
      this.stop();
      this.setValue(res.result);
    }).catch(err => this.stop());
  }

  obterAreasInteresseContribuinte() {
    this.start();
    const obj: any = {
      codContribuinte: this.getCodContribuinte()
    };
    this.contribuinteService.obterAreaInteresse(obj).then((res: any) => {
      this.stop();
      let areasInteresse = res.result as Array<AreaInteresse>;
      this.setAreasInteresse(areasInteresse);
      let codigosAreaInteresse: Array<number> = [];
      areasInteresse.forEach(x => codigosAreaInteresse.push(x.codigo));
      this.filter.setCodigosAreaInteresse(codigosAreaInteresse);
      this.consultar(0, 10, true, null, null, true, codigosAreaInteresse);
    }).catch(err => this.stop());
  }
  consultar(page: number = 0, pageSize: number = 10, isClean = false, e?: any, ordering: any = null, isInit = false, codigosAreaInteresse: Array<number> = []) {
    let obj: any = { ...this.filter };
    obj.page = page;
    obj.pageSize = pageSize;
    if (isClean) {
      obj = { ordering: 'ano' };
      obj.page = 0;
      obj.pageSize = 10;
    }
    if (ordering != null) {
      obj.ordering = ordering;
    }
    if (this.filter.codigoSituacao > 0) {
      obj.codigoSituacao = this.filter.codigoSituacao;
      obj.codigoTipoEvento = this.filter.codigoTipoEvento;
      obj.codigoAno = this.filter.codigoAno;
      obj.numeroAudiencia = this.filter.numeroAudiencia;
      obj.busca = this.filter.busca;
    }
    if (!isInit) {
      if (!obj.codigoAno && !obj.codigoSituacao && !obj.codigoTipoEvento && !obj.numeroAudiencia) {
        ToastService.showWarn(Mensagem.MSG_E055);
        return;
      }
    }
    else {
      this.filter.setCodigoSituacao(2);
      obj.codigoSituacao = 2;//this.filter.codigoSituacao;
      obj.codigoAno = 0;
      obj.codigoTipoEvento = 0;
      obj.numeroAudiencia = '';
      obj.busca = '';
    }
    if (this.filter.codigosAreaInteresse.length > 0 || codigosAreaInteresse.length > 0) {
      obj.codigosAreaInteresse = this.filter.codigosAreaInteresse.length > 0 ? this.filter.codigosAreaInteresse : codigosAreaInteresse;
    }
    this.start();
    this.service
      .findAll(obj)
      .then((res) => {
        this.stop();
        if (e) {
          this.setLazyParams(e);
        }
        if (res.result && res.result.items) {
          this.setLista(res.result.items);
          this.setTotal(res.result.totalItems);
          let datas: Array<Date> = [];
          let datasString: Array<string> = [];
          res.result.items.forEach((evento: EventoModel) => {
            let dtInicioValidade = (evento.dtInicioValidade as string).split('T')[0].replaceAll('-', '/');
            let dtFimValidade = (evento.dtFimValidade as string).split('T')[0].replaceAll('-', '/');
            datas.push(new Date(dtInicioValidade), new Date(dtFimValidade));
            this.retornaIntervaloDeDatas(new Date(dtInicioValidade), new Date(dtFimValidade), datas, datasString);

          });
          this.setDates(datas.sort());
          this.selecionarEventosPelocalendario(new Array<Date>(new Date(Date.now())), res.result.items);
        } else {
          this.setLista([]);
          this.setTotal(0);
        }
      })
      .catch((err) => this.stop());
  }
  retornaIntervaloDeDatas(dtInicio: Date, dtFim: Date, datas: Array<Date>, datasString: Array<string>): Array<Date> {
    while (dtInicio < dtFim) {
      dtInicio.setDate(dtInicio.getDate() + 1);

      const mes = dtInicio.getMonth() + 1;
      let todayMonth;
      if (mes < 10) {
        todayMonth = '0' + mes;
      } else {
        todayMonth = mes.toString();
      }
      let stringData = `${dtInicio.getFullYear()}/${todayMonth}/${dtInicio.getDate()}`;
      let data = new Date(stringData);
      if (!datasString.includes(stringData)) {
        datas.push(data);
        datasString.push(stringData);
      }
    };
    return datas;
  }

  selecionarEventosPelocalendario(value: any, listaEventos: Array<any>) {
    this.setlistaTemporaria([]);
    let datasEscolhidas = Array.isArray(value) ?
      value as Array<Date> : new Array<Date>(value as Date);
    datasEscolhidas = new Array<Date>(datasEscolhidas[datasEscolhidas.length - 1]);
    let datasEvento: Array<Date> = [];
    let datasString: Array<string> = [];
    let eventos: Array<any> = [];
    listaEventos = this.lista.length == 0 ? listaEventos : this.lista;
    listaEventos.forEach((evento: EventoModel) => {
      let dtInicioValidade = (evento.dtInicioValidade as string).split('T')[0].replaceAll('-', '/');
      let dtFimValidade = (evento.dtFimValidade as string).split('T')[0].replaceAll('-', '/');
      datasEvento.push(new Date(dtInicioValidade), new Date(dtFimValidade));
      this.retornaIntervaloDeDatas(new Date(dtInicioValidade), new Date(dtFimValidade), datasEvento, datasString);
      const intersection = datasEvento.filter((item1) =>
        datasEscolhidas.some((item2) => item1.getFullYear() == item2.getFullYear()
          && item1.getMonth() == item2.getMonth()
          && item1.getDate() == item2.getDate()
        )
      )

      if (intersection.length > 0) {
        eventos.push(evento);
      }

      datasEvento = [];
      datasString = [];
    });

    this.setlistaTemporaria(eventos);
  }

  onClickMeusEventos(value: any) {
    this.history.push('/meus-eventos/inicio', { desiredTab: value });
  }


  onClickMinhasContribuicoes(value: any) {
    this.history.push('/minhas-contribuicoes/inicio', { desiredTab: value });
  }



}
